import styled from 'styled-components';

export const Title = styled.h2`
  all: unset;
  color: ${({ theme }) => theme.colors.primaryText};
  display: block;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  margin-bottom: 10px;
`;

export const Subtitle = styled.p`
  all: unset;
  color: ${({ theme }) => theme.colors.primaryText};
  display: block;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  margin-bottom: 10px;

  & > svg {
    margin-right: 10px;
    vertical-align: middle;
  }
`;

export const Description = styled.p`
  color: ${({ theme }) => theme.colors.primaryText};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 10px;
  max-width: 800px;
`;

type ButtonProps = {
  inactive?: boolean;
};

export const Button = styled.button<ButtonProps>`
  all: unset;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.primary};
  font-size: 14px;
  font-weight: 600;
`;
